const CCP_NEW_URLS = {
    PROD: {
        login: "https://sso-internal.searshc.com/amazon-connect-new",
        ccp: "https://transformco-prod.my.connect.aws/ccp-v2"
    }, DEV: {
        login: "https://transformholding--acdev00.my.connect.aws/login",
        ccp: "https://transformholding--acdev00.my.connect.aws/ccp-v2"
    }
}


export default CCP_NEW_URLS;